import { useGateway } from '@ad-lucy/gateway-provider';
import {
  DefaultActionsErrorView,
  ErrorBoundary,
  LoaderCentered,
} from '@modules/components';
import RemoteMediaPlanning from '@modules/remotes/mediaplanning';
import { Suspense } from 'react';

function AdmModuleMediaPlanning() {
  const gateway = useGateway();

  return (
    <ErrorBoundary fallback={<DefaultActionsErrorView />}>
      <Suspense fallback={<LoaderCentered />}>
        <RemoteMediaPlanning gateway={gateway} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default AdmModuleMediaPlanning;
